import { AdminTemplate, PaymentWithLinkedListFilter } from "../../components";

export const PaymentWithLinkedList = () => {
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "",
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true,
      }}
      showHeaderTitle={false}>
      <PaymentWithLinkedListFilter />
    </AdminTemplate>
  );
};
